import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { API } from '../../config/api';
import { environment } from '../../../../environments/environment';
import { GOOGLEMAP_KEY } from 'src/@shared/constants';
import { CreateCollectionRequest } from './collection.model';
import { ConsigmentPricing } from '../../../models/consignment';
import { tap } from 'rxjs/operators';
import { BoSpinnerService } from 'src/@core/shared';

@Injectable()
export class CollectionService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        ) {
        }
    public getCustomerInfo(): Observable<any> {
      this._spinner.show();
        return this._http.get(this.baseUrl + `${API.CUSTOMER_PORTAL.COLLECTION.GET_CURRENT_CUSTOMER_DETAIL}`).pipe(tap(() => this._spinner.hide()));
    }


  //public getQuoteInfo(): Observable<any> {
  //  return this._http.get(this.baseUrl + `${API.CUSTOMER_PORTAL.COLLECTION.GET_CURRENT_CUSTOMER_DETAIL}`);
  //}

    public lookPostCode(postCode: string): Observable<any> {
        const apiUrl = API.GOOGLE_MAP.CALLGEOAPI(postCode, GOOGLEMAP_KEY);
        return this._http.get(apiUrl);
    }

    public create(model: CreateCollectionRequest) {
        return this._http.post(`${API.CUSTOMER_PORTAL.COLLECTION.CREATE}`, model);
  }
  public getPrice(model: CreateCollectionRequest) {
    this._spinner.show();
    return this._http.post<ConsigmentPricing>(`${API.CUSTOMER_PORTAL.COLLECTION.GET_PRICE}`, model).pipe(tap(() => this._spinner.hide()));
  }
}
